import {Component, OnInit} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {IFilter} from 'src/app/interfaces/settings.iterfaces';
import {SettingsService} from 'src/app/services/settings.service';
import {DialogRef} from 'src/app/shared/ui-kits/dialog/dialog-ref';
import {Utils} from 'src/app/shared/utils/utils';

@UntilDestroy()
@Component({
  selector: 'app-office-modal',
  templateUrl: './office-modal.component.html',
  styleUrls: ['./office-modal.component.scss'],
})
export class OfficeModalComponent implements OnInit {
  public form!: UntypedFormGroup;
  public countrySearch = new UntypedFormControl();
  public selectedCountry: IFilter = {
    name: 'Country',
    data: [{id: 1, name: 'Ukraine'}],
  };
  dropdown: string[] = [];
  public isFieldInvalid = Utils.isFieldInvalid;

  constructor(
    private fb: UntypedFormBuilder,
    private settingService: SettingsService,
    private dialogRef: DialogRef
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      officeName: new UntypedFormControl(null, [
        Validators.required,
        Validators.maxLength(40),
      ]),
      countryName: new UntypedFormControl(null, [Validators.required]),
      address: new UntypedFormControl(null, [
        Validators.required,
        Validators.maxLength(40),
      ]),
    });
    this.settingService
      .getCountriesList()
      .pipe(untilDestroyed(this))
      .subscribe(response => {
        this.selectedCountry = this.keyPairTransformer(response);
      });
  }

  keyPairTransformer(countries: string[]): IFilter {
    const countiesKeyPair = countries.map((country, index) => {
      return {
        id: index,
        name: country,
      };
    });
    return {
      name: 'Countries',
      data: countiesKeyPair,
    };
  }

  saveTheData() {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value);
    } else {
      Utils.validateAllFormFields(this.form);
    }
  }

  closeTheModal() {
    this.dialogRef.close();
  }
}
